export default __webpack_public_path__ + "static/media/bc_print.b2f99441.png";